import { render, staticRenderFns } from "./SelectTruck.vue?vue&type=template&id=7fd5ec8e&"
import script from "./SelectTruck.vue?vue&type=script&lang=ts&"
export * from "./SelectTruck.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7fd5ec8e')) {
      api.createRecord('7fd5ec8e', component.options)
    } else {
      api.reload('7fd5ec8e', component.options)
    }
    module.hot.accept("./SelectTruck.vue?vue&type=template&id=7fd5ec8e&", function () {
      api.rerender('7fd5ec8e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/custom/select/SelectTruck.vue"
export default component.exports